<template>
  <div class="nuttrema-layout-popover-cred">
    <div class="nuttrema-layout-popover-cred__top">
      <slot name="top"></slot>
    </div>
    <div class="nuttrema-layout-popover-cred__center">
      <div class="nuttrema-layout-popover-cred__center__header">
        <slot name="center-header"></slot>
      </div>
      <div class="nuttrema-layout-popover-cred__center__content">
        <slot name="center-content"></slot>
      </div>
    </div>
    <div class="nuttrema-layout-popover-cred__bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-layout-popover-cred',
};
</script>

<style lang="scss" scoped>
  .nuttrema-layout-popover-cred {
    display: flex;
    flex-grow: 1;
    height: 100%;
    max-height: 100%;
    flex-direction: column;
    background-color: #fff;
    justify-content: space-between;

    @at-root #{&}__top {
      align-self: stretch;
      flex-shrink: 0;
      .nav {
        min-height: 3rem;
        border-bottom: 2px solid #DBE2EF;
        .nav-item--title {
          font-weight: 600;
        }
      }
    }

    @at-root #{&}__center {
      flex-grow: 1;
      display: flex;
      align-self: stretch;
      flex-direction: column;
      background-color: rgba(#DBE2EF, 0.25);
      overflow: hidden;

      @at-root #{&}__header {
        flex-shrink: 0;
        align-self: stretch;
      }

      @at-root #{&}__content {
        flex-grow: 1;
        display: flex;
        overflow-y: auto;
        flex-direction: column;
      }
    }

    @at-root #{&}__bottom {
      flex-shrink: 0;
      align-self: stretch;
      border-top: 2px solid #DBE2EF;
      .nav {
        .nav-right--grow-less {
          flex-grow: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-popover-cred.vue